import React, { Component } from 'react';
import "./NewsletterPage.scss";
import { SimpleButton } from '../../components/buttons/simple/SimpleButton';
import logo from '../../content/Mediti.svg';
import RoutingService from '../../services/routingService';
import apiRoutingService from '../../services/apiRoutingService';

type NewsletterPageProps = {};

interface NewsletterPageState {
    emailButtonText: string;
    email: string;
    navScrolled: boolean;
    emailError: string;
}

export default class NewsletterPage extends Component<NewsletterPageProps, NewsletterPageState> {

    readonly signUpText = "Zapisuję się";
    readonly signingUpText = "Zapisuję...";
    readonly signedUpText = "Zapisano";
    readonly communicationError = "Wystąpił błąd, spróbuj później.";
    readonly emailNotValidError = "Podaj poprawny adres e-mail.";

    constructor(props: NewsletterPageProps) {
        super(props);

        this.state = {
            emailButtonText: this.signUpText,
            email: "",
            navScrolled: false,
            emailError: ""
        };

        this.signUpForNewsletter = this.signUpForNewsletter.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    private handleScroll() {
        this.setState({ navScrolled: window.scrollY > 50 });
    }

    private isEmailValid(email: string): boolean {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    private extractNameFromEmail(email: string): string {
        return email.split('@')[0];
    }

    private async signUpForNewsletter() {
        if (!this.isEmailValid(this.state.email)) {
            this.setState({ emailError: this.emailNotValidError });
            return;
        }

        this.setState({ emailButtonText: this.signingUpText, emailError: "" });

        const name = this.extractNameFromEmail(this.state.email);

        try {
            await apiRoutingService.signUpForNewsletter(this.state.email, name);
            this.setState({ emailButtonText: this.signedUpText });
        } catch {
            this.setState({
                emailButtonText: this.signUpText,
                emailError: this.communicationError
            });
        }
    }

    public render() {
        return (
            <div className="nl-page">
                <nav className={`nl-nav${this.state.navScrolled ? ' scrolled' : ''}`}>
                    <a href={RoutingService.getMainPageRoute()} className="nl-nav-logo">
                        <img src={logo} alt="Mediti" />
                    </a>
                    <a href={RoutingService.getMainPageRoute()} className="nl-nav-back">
                        Powrót do strony głównej
                    </a>
                </nav>

                <section className="nl-hero">
                    <div className="nl-hero-content">
                        <h1 className="nl-heading">Kilka minut spokoju w Twojej skrzynce</h1>
                        <p className="nl-subtitle">
                            Inspiracje, nowe medytacje i krótkie przypomnienia, które pomagają wracać do siebie.
                        </p>

                        <div className="nl-form">
                            <input
                                type="email"
                                className="nl-email-input"
                                placeholder="Twój adres e-mail"
                                value={this.state.email}
                                onChange={e => this.setState({ email: e.target.value })}
                            />
                            <SimpleButton
                                text={this.state.emailButtonText}
                                onClick={this.signUpForNewsletter}
                            />
                        </div>

                        {this.state.emailError && (
                            <p className="nl-validation-error">{this.state.emailError}</p>
                        )}
                        <p className="nl-spam-note">Nie wysyłamy spamu. Możesz wypisać się w każdej chwili.</p>
                    </div>
                </section>

                <section className="nl-features">
                    <div className="nl-features-inner">
                        <h2 className="nl-features-heading">Co otrzymasz?</h2>
                        <div className="nl-features-grid">
                            <div className="nl-feature">
                                <strong>Nowe medytacje</strong>
                                <span>Informacje o nowych praktykach w aplikacji.</span>
                            </div>
                            <div className="nl-feature">
                                <strong>Krótkie inspiracje</strong>
                                <span>1–2 minutowe refleksje i przypomnienia.</span>
                            </div>
                            <div className="nl-feature">
                                <strong>Spokojne wiadomości</strong>
                                <span>Bez nadmiaru. Bez presji. Kilka razy w miesiącu.</span>
                            </div>
                        </div>
                        <p className="nl-closing">Dołącz do osób, które chcą wracać do spokoju w codzienności.</p>
                    </div>
                </section>
            </div>
        );
    }
}
